import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Copy } from '@honda-canada/design-system-react';
import formatPrice from '@honda-canada/js-utilities/lib/formatPrice';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../../utils/sitecoreContext';
import Superscript from '../shared/Superscript';
import themeStyles from '../styles/PaymentTabs.styles';
import SpecialOfferIcon from './SpecialOfferIcon';
const Title = themeStyles.apply(Copy, 'Title');
const NumberText = themeStyles.apply(Copy, 'NumberText');
const CashRebateContainer = themeStyles.apply(Box, 'CashRebateContainer');
const RebateAmountContainer = themeStyles.apply(Box, 'RebateAmountContainer');
const CashRebateInfo = ({ cashRebate, superscript, }) => {
    const { t } = useTranslation();
    const language = useLanguage();
    if (!cashRebate)
        return null;
    const { rebateAmount } = cashRebate;
    return (_jsxs(CashRebateContainer, { "data-testid": "cy-special-offer-card-cash-rebate", children: [_jsx(Title, { size: "small", paddingLeft: [null, null, '22px'], children: t('Cash Rebate Available') }), _jsxs(RebateAmountContainer, { "data-testid": "cy-special-offer-card-rebate-ammount", children: [_jsx(SpecialOfferIcon, {}), _jsxs(NumberText, { children: [formatPrice(rebateAmount, language), _jsx(Superscript, { ...superscript, ml: "xxs" })] })] })] }));
};
export default CashRebateInfo;
